// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2bvg6","buttons":"SendReceipts_buttons__1w9vu","email":"SendReceipts_email__2sVg2","bookApptTitle":"SendReceipts_bookApptTitle__a8Uor"};